module.exports = __webpack_public_path__ + "img/badge-2.23dccb47.svg";